import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box } from 'grommet/components/Box';
import { Heading } from 'grommet/components/Heading';
import { Paragraph } from 'grommet/components/Paragraph';
import { CheckBox } from 'grommet/components/CheckBox';
import { Button } from 'grommet/components/Button';
import Header from '../Components/Header.js';
import Footer from '../Components/Footer.js';
import Form from '../Components/Form.js';
import { ERRORMESSAGE } from '../Constants.js';
import { withRouter } from "react-router-dom";
import { RegisterMerchantCtrl } from '../Controllers/Account/Registrazione/RegisterMerchantCtrl.js';
import { RegisterPVCtrl } from '../Controllers/Account/Registrazione/RegisterPVCtrl.js';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
import { loader } from '../Utils/Utility.js';


class Registration extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            checked: false,
            nome: '',
            cognome: '',
            codicefiscale: '',
            codsocieta: '',
            capsocieta: '',
            codicepv: '',
            piva: '',
            email: '',
            numtel: '',
            msgcodsoc: '',
            msgcapsoc: '',
            msgpiva: '',
            msgcodfis: '',
            msgemail: '',
            msgnumtel: '',
            msgcodpv: '',
            status: '',
            code: '',
            showTimeoutModal: false,
            showError: false,
            loading: false,
            captcha: true //seting to false when captcha

        }
        this.setCheckbox = this.setCheckbox.bind(this);
        this.setForm = this.setForm.bind(this);
        this.validForm = this.validForm.bind(this);
        this.goToValidate = this.goToValidate.bind(this);
        this.captcha = this.captcha.bind(this);
    }


    setCheckbox() {
        this.setState({
            checked: !this.state.checked
        })
    }

    setForm(event) {

        if (event.target.id === 'codsoc') {
            this.setState({
                codsocieta: event.target.value
            })
        } else if (event.target.id === 'piva') {
            this.setState({
                piva: event.target.value
            })
        } else if (event.target.id === 'capsoc') {
            this.setState({
                capsocieta: event.target.value
            })
        } else if (event.target.id === 'nomelegale') {
            this.setState({
                nome: event.target.value
            })
        } else if (event.target.id === 'cognomelegale') {
            this.setState({
                cognome: event.target.value
            })
        } else if (event.target.id === 'codfislegale') {
            this.setState({
                codicefiscale: event.target.value
            })
            
        } else if (event.target.id === 'codpv') {
            this.setState({
                codicepv: event.target.value
            })
        } else if (event.target.id === 'numtel') {
            this.setState({
                numtel: event.target.value
            })
        } else if (event.target.id === 'email') {
            this.setState({
                email: event.target.value
            })
        }
    }

    validForm(event) {
        var codsoc = this.state.codsocieta;
        var piva = this.state.piva;
        var capsoc = this.state.capsocieta;
        var codicefiscale = this.state.codicefiscale;
        var codpv = this.state.codicepv;
        var email = this.state.email;
        var tel = this.state.numtel;
        var nome = this.state.nome;
        var cognome = this.state.cognome;

        //var codfis = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i;
        //var codfis= /^[A-Za-z]{6}\d{2}[A-Za-z]\d{2}[A-Za-z]\d{2,3}[A-Za-z]{1,2}$/i;
        var codfis = /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i;
        //const emailreg = /^([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})$/;
        const emailreg = /^([a-zA-Z0-9_.-]+)@([\da-zA-Z.-]+)\.([a-zA-Z.]{2,6})$/;
        var numberTel =  /^\+(?:[0-9] ?){2,15}[0-9]$/;
        var letter = /[a-zA-Z]/;
        var number = /^\d+$/;



        if (event.target.id === 'codsoc') {
            if (codsoc !== '' && number.test(codsoc) === false) { // Validazione codice società
                this.setState({
                    msgcodsoc: ERRORMESSAGE.msgnumber,
                    codSocOk: false
                })
            } else if (codsoc !== '' && number.test(codsoc) === true && codsoc.length < 10) {
                this.setState({
                    msgcodsoc: ERRORMESSAGE.msglengthcodsoc,
                    codSocOk: false
                })
            } else if (codsoc !== '' && number.test(codsoc) === true) {
                this.setState({
                    msgcodsoc: '',
                    codSocOk: true
                })
            } else if (codsoc === '') {
                this.setState({
                    msgcodsoc: ERRORMESSAGE.msgblank,
                    codSocOk: false
                })
            }
        } else if (event.target.id === 'piva') {
            if (piva !== '' && number.test(piva) === false) { // Validazione partita iva
                this.setState({
                    msgpiva: ERRORMESSAGE.msgnumber,
                    codPivaOk: false
                })
            } else if (piva !== '' && number.test(piva) === true && piva.length < 11) {
                this.setState({
                    msgpiva: ERRORMESSAGE.msglengthpiva,
                    codPivaOk: false
                })
            } else if (piva !== '' && number.test(piva) === true) {
                this.setState({
                    msgpiva: '',
                    codPivaOk: true
                })
            } else if (piva === '') {
                this.setState({
                    msgpiva: ERRORMESSAGE.msgblank,
                    codPivaOk: false
                })
            }
        } else if (event.target.id === 'capsoc') {
            if (capsoc !== '' && number.test(capsoc) === false) { // Validazione cap società
                this.setState({
                    msgcapsoc: ERRORMESSAGE.msgnumber,

                })
            } else if (capsoc !== '' && number.test(capsoc) === true && capsoc.length < 5) {
                this.setState({
                    msgcapsoc: ERRORMESSAGE.msglengthcapsoc,
                    capSocOk: false
                })
            } else if (capsoc !== '' && number.test(capsoc) === true) {
                this.setState({
                    msgcapsoc: '',
                    capSocOk: true
                })
            } else if (capsoc === '') {
                this.setState({
                    msgcapsoc: ERRORMESSAGE.msgblank,
                    capSocOk: false
                })
            }
        } else if (event.target.id === 'codfislegale') {
            if (codicefiscale !== '' && codfis.test(codicefiscale) === false) { // Validazione codice fiscale
                this.setState({
                    msgcodfis: ERRORMESSAGE.msgcodfis,
                    codFisOk: false
                })
            } else if (codicefiscale !== '' && codfis.test(codicefiscale) === true) {
                this.setState({
                    msgcodfis: '',
                    codFisOk: true
                })
            } else if (codicefiscale === '') {
                this.setState({
                    msgcodfis: ERRORMESSAGE.msgblank,
                    codFisOk: false
                })
            }
        } else if (event.target.id === 'email') {
            if (email !== '' && emailreg.test(email) === false) { // Validazione email
                this.setState({
                    msgemail: ERRORMESSAGE.msgemail,
                    emailOk: false
                })
            } else if (email !== '' && emailreg.test(email) === true && email.length < 6) {
                this.setState({
                    msgemail: ERRORMESSAGE.msglengthemail,
                    emailOk: false
                })
            } else if (email !== '' && emailreg.test(email) === true) {
                this.setState({
                    msgemail: '',
                    emailOk: true
                })
            } else if (email === '') {
                this.setState({
                    msgemail: ERRORMESSAGE.msgblank,
                    emailOk: false
                })
            }
        } else if (event.target.id === 'numtel') {
            if (tel !== '' && numberTel.test(tel) === false) { // Validazione numero telefono
                this.setState({
                    msgnumtel: 'Inserire un numero internazionale corretto (+112345, +3912345)',
                    numTelOk: false
                })
            } else if (tel !== '' && numberTel.test(tel) === true && tel.length < 3) {
                this.setState({
                    msgnumtel: ERRORMESSAGE.msglengthphonenumber,
                    numTelOk: false
                })
            } else if (tel !== '' && numberTel.test(tel) === true) {
                this.setState({
                    msgnumtel: '',
                    numTelOk: true
                })
            } else if (tel === '') {
                this.setState({
                    msgnumtel: ERRORMESSAGE.msgblank,
                    numTelOk: false
                })
            }
        } else if (event.target.id === 'codpv') {
            if (codpv !== '' && number.test(codpv) === false) { // Validazione codice punto vendita
                this.setState({
                    msgcodpv: ERRORMESSAGE.msgnumber,
                    codPvOk: false
                })
            } else if (codpv !== '' && number.test(codpv) === true && codpv.length < 10) {
                this.setState({
                    msgcodpv: ERRORMESSAGE.msglengthcodsoc,
                    codPvOk: false
                })
            } else if (codpv !== '' && number.test(codpv) === true) {
                this.setState({
                    msgcodpv: '',
                    codPvOk: true
                })
            } else if (codpv === '') {
                this.setState({
                    msgcodpv: ERRORMESSAGE.msgblank,
                    codPvOk: false
                })
            }
        } else if (event.target.id === 'nomelegale') {
            if (nome === '') {
                this.setState({
                    msgnomleg: ERRORMESSAGE.msgblank,
                    nomLegOk: false
                })
            } else if (nome !== '' && letter.test(nome) === true) {
                this.setState({
                    msgnomleg: '',
                    nomLegOk: true
                })
            } else if (nome !== '' && letter.test(nome) === false) {
                this.setState({
                    msgnomleg: ERRORMESSAGE.msgletter,
                    nomLegOk: false
                })
            }
        } else if (event.target.id === 'cognomelegale') {
            if (cognome === '') {
                this.setState({
                    msgcogleg: ERRORMESSAGE.msgblank,
                    cogLegOk: false
                })
            } else if (cognome !== '' && letter.test(cognome) === true) {
                this.setState({
                    msgcogleg: '',
                    cogLegOk: true
                })
            } else if (cognome !== '' && letter.test(cognome) === false) {
                this.setState({
                    msgcogleg: ERRORMESSAGE.msgletter,
                    cogLegOk: false
                })
            }
        }
    }


    goToValidate() {
        const uuidv1 = require('uuid/v1');
        sessionStorage.setItem('ids', uuidv1());
        var ids = sessionStorage.getItem("ids");
        const self = this;
        
        this.setState({
            loading: true
        });

        if (window.location.pathname === '/SocietyRegistration') {

            RegisterMerchantCtrl(function (data, status) {
                self.setState({
                    data: data,
                    status: status,
                    loading: false
                }, function () {
                    if (this.state.status === 200) {
                        this.props.history.push({
                            pathname: '/ValidateRegistration',
                            step: 2,
                            state: { numtel: this.state.numtel, code: 'society' }

                        })
                    }
                });

            }, function (error) {
                self.setState({
                    status: error,
                    loading: false
                }, function () {
                    if (this.state.status === 400 || this.state.status === 404 || this.state.status === 403 || this.state.status === 406) {
                        this.props.history.push({
                            pathname: '/ErrorPageReg',
                            state: this.state,
                            code: 'society'
                        })
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                    } else if(this.state.status === 500) {
                        this.setState({
                            showError: true
                        })
                        window.scrollTo(0, 0);
                        //$('html, body').animate({ scrollTop: 0 }, 'fast');
                    }
                })
            }, this.state, ids);

        } else {

            RegisterPVCtrl(function (data, status) {
                self.setState({
                    data: data,
                    status: status,
                    loading: false
                }, function () {
                    if (this.state.status === 200) {
                        this.props.history.push({
                            pathname: '/ValidateRegistration',
                            state: { numtel: this.state.numtel, code: 'shop', email: this.state.email },
                            step: 2

                        })
                    }
                });

            }, function (error) {
                self.setState({
                    status: error,
                    loading: false
                }, function () {
                    if (this.state.status === 400 || this.state.status === 404 || this.state.status === 403 || this.state.status === 406) {
                        this.props.history.push({
                            pathname: '/ErrorPageReg',
                            state: this.state,
                            code: 'shop'
                        })
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                    } else if(this.state.status === 500) {
                        this.setState({
                            showError: true
                        })
                        window.scrollTo(0, 0);
                        //$('html, body').animate({ scrollTop: 0 }, 'fast');
                    }
                })
            }, this.state, ids);
        }
    }

    componentWillMount() {
        if (this.props.location.step !== 1) {
            this.props.history.push({
                pathname: '/login'
            })
        }
    }

    captcha(value) {
        if (value !== "") {
            this.setState({
                captcha: true
            })
        }
    }

    render() {

        //const isEnabledSocieta = this.state.codsocieta !== '' && this.state.piva !== '' && this.state.capsocieta !== '' && this.state.codicefiscale !== '' && this.state.email !== '' && this.state.numtel !== '' && this.state.nome !== '' && this.state.cognome !== '' && this.state.checked;
        const isEnabledSocieta = this.state.codSocOk && this.state.codPivaOk && this.state.capSocOk && this.state.codFisOk && this.state.emailOk && this.state.numTelOk && this.state.nomLegOk && this.state.cogLegOk && this.state.checked;
        const isEnabledPV = this.state.codPvOk && this.state.codSocOk && this.state.codPivaOk && this.state.capSocOk && this.state.emailOk && this.state.numTelOk && this.state.checked;

        return (
            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Header />

                <Box className='registration-form'>
                    <Box className='content' style={{ backgroundColor: '#F9F9F9', height: '100%', width: '100%' }} align='center'>
                        <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>
                            {window.location.pathname === "/SocietyRegistration" ? "Registrazione Società" : "Registrazione Punto Vendita"}
                        </h1>
                        {this.state.showError ? <span style={{color: "#E1242B", marginBottom: "20px", height: "20px"}}>I dati non corrispondono al Codice Società specificato</span> : <span style={{color: "red", marginBottom: "20px", height: "20px"}}></span>}
                        <Box>
                            <Form nome={this.state.nome} cognome={this.state.cognome} codicefiscale={this.state.codicefiscale}
                                codsocieta={this.state.codsocieta} capsocieta={this.state.capsocieta} codicepv={this.state.codicepv}
                                piva={this.state.piva} email={this.state.email} numtel={this.state.numtel} onChange={this.setForm} onBlur={this.validForm} msgnomleg={this.state.msgnomleg}
                                msgcodsoc={this.state.msgcodsoc} msgcapsoc={this.state.msgcapsoc} msgpiva={this.state.msgpiva} /*msgcapsoc={this.state.msgcapsoc}*/ msgcogleg={this.state.msgcogleg}
                                msgcodfis={this.state.msgcodfis} msgemail={this.state.msgemail} msgnumtel={this.state.msgnumtel} msgcodpv={this.state.msgcodpv} />
                            {/* <ReCAPTCHA
                                sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                                onChange={this.captcha}
                            /> */}
                        </Box>
                    </Box>

                    <Box align='center' className='content'>
                        <Box direction='column' id="informativaReg" className='informativa'>

                            <Heading id='first-title' level='3' className='titleParagraph'>
                                Informativa in materia di dati personali
                            </Heading>
                            <Paragraph className='textParagraph'>
                                Prima di procedere, ti invitiamo a prendere visione dell'informativa relativa al trattamento dei dati personali.
                            <br />
                                <br />
                                <textarea style={{ width: '100%', height: '100px' }}>
                                    INFORMATIVA SUL TRATTAMENTO DEI DATI PERSONALI
                                     Ai sensi dell'art. 13 del Decreto Legislativo 30 giugno 2003, n. 196 recante il "Codice in materia di protezione dei dati personali" ("Codice"), American Express Payment Services Limited, con sede secondaria per l'Italia, in Roma, in Viale Alexandre Gustave Eiffel n. 15, 00148 ("AEPSL" o "American Express"), quale titolare del trattamento ai sensi dell'art. 4 del Codice, fornisce ai propri esercizi ("Esercizi") e agli eventuali dipendenti, collaboratori, consulenti, amministratori o rappresentanti dell'Esercizio con i quali American Express dovesse entrare in contatto nell'ambito del rapporto con quest'ultimo le seguenti informazioni sull'utilizzo dei dati personali.
                                     (i) Fonte dei dati. I dati personali dell'Esercizio (se persona fisica) e dei dipendenti, collaboratori, consulenti, amministratori o rappresentanti dell'Esercizio con i quali American Express dovesse entrare in contatto nell'ambito del rapporto con lo stesso sono raccolti direttamente presso l'Esercizio, il quale si impegna a fornire a tali soggetti, in nome e per conto di American Express, un'informativa di contenuto analogo alla presente informativa e ad ottenere dagli stessi il consenso informato e specifico per il trattamento dei loro dati personali previsto dalla presente informativa.
                                     (ii) Finalità del trattamento. I dati personali raccolti nel modulo di richiesta ovvero nel corso del rapporto contrattuale con American Express, saranno trattati per le seguenti finalità: (a) adempimento ad obblighi previsti da leggi, da regolamenti, dalla normativa europea, nonché dalle istruzioni delle autorità di vigilanza, ivi compreso l'adempimento degli obblighi previsti dalla normativa antiriciclaggio e contro il finanziamento del terrorismo; (b) gestione ed esecuzione del rapporto pre-contrattuale e/o contrattuale con l'Esercizio, sia in Italia che al di fuori dell'Unione Europea, attraverso l'inserimento dei dati nei sistemi informatici di AEPSL e di società controllate/collegate (di seguito, collettivamente, il "Gruppo American Express") nonchè di società terze, ivi compresa l'elaborazione degli addebiti effettuati presso i punti vendita dell'Esercizio, la contabilizzazione dei pagamenti dovuti a o da American Express, il controllo della qualità del servizio offerto (anche mediante questionari per la valutazione della soddisfazione dell'Eservizio), la gestione del rischio di credito e del rischio di frodi connessi ai servizi prestati da American Express e/o dal Gruppo American Express; (c) finalità promozionali. In particolare, se l'Esercizio ha prestato il proprio consenso, American Express, le società del Gruppo American Express, nonché le società selezionate dalle stesse, potranno raccogliere, utilizzare, trasferire e conservare i dati che riguardano l'Esercizio e, in particolare, quelli relativi al modo in cui le carte American Express sono utilizzate dai relativi titolari presso i punti vendita dell'Esercizio, per sviluppare elenchi ad utilizzo delle varie società del Gruppo American Express in tutto il mondo e delle altre società da esse selezionate, al fine di elaborare offerte di prodotti e/o servizi da proporre all'Esercizio stesso (a mezzo posta e/o telefono e/o posta elettronica e/o mediante altre modalità digitali). Le informazioni utilizzate per sviluppare questi elenchi possono essere ottenute dal modulo di richiesta, da indagini e ricerche (che possono implicare contatti con l'Esercizio via posta o telefono o posta elettronica e/o mediante altre modalità digitali), nonché da altre fonti esterne quali organizzazioni od associazioni di esercenti o di marketing, o da fonti accessibili al pubblico.
                                     (iii) Modalità del trattamento. In relazione alle indicate finalità, il trattamento dei dati avverrà in modo da garantirne la sicurezza e la riservatezza e potrà essere effettuato attraverso strumenti manuali, informatici e telematici atti a memorizzare, gestire e trasmettere i dati stessi. Le logiche del trattamento saranno strettamente correlate alle illustrate finalità. In particolare, American Express potrà monitorare (direttamente o tramite società da essa designate) le telefonate provenienti dall'Esercizio ai numeri telefonici di American Express per garantire livelli di assistenza e gestione clienti costantemente elevati. American Express potrà trattare i dati anche in Paesi al di fuori dello Spazio Economico Europeo e, in particolare, negli Stati Uniti, o accedere ad essi in tali Paesi, dove le leggi sulla protezione dei dati potrebbero non essere altrettanto complete. Tuttavia, American Express ha adottato opportune misure affinché anche in tali Paesi i dati personali degli interessati godano del medesimo grado di protezione che nell'Unione Europea.
                                     (iv) Natura obbligatoria/facoltativa del conferimento. Il conferimento dei dati, siano essi acquisiti in base ad un obbligo di legge ovvero in quanto strettamente funzionali all'instaurazione e prosecuzione del rapporto contrattuale, è necessario ed un eventuale rifiuto al conferimento e trattamento avrà come conseguenza l'impossibilità di instaurare e proseguire il rapporto contrattuale. Diversamente, il conferimento dei dati per le finalità di cui al precedente paragrafo (ii) lettera (c) è facoltativo e l'Esercizio potrà escludere in qualsiasi momento uno o più degli utilizzi dei propri dati previsti dalla suddetta lettera (c) facendone richiesta, anche telefonica, ad American Express.
                                     (v) Categorie di soggetti ai quali i dati possono essere comunicati o che possono venirne a conoscenza, (a) società del Gruppo American Express in virtù di esigenze organizzative che comportino l'inserimento dei dati - e quindi il relativo trasferimento - all'interno dei sistemi informatici del Gruppo American Express. L'elenco dei Paesi in cui è presente American Express è ottenibile presso gli uffici della stessa American Express; (b) acquirenti, fornitori e qualunque persona alla quale American Express è tenuta a comunicare i dati, nell'ambito della gestione del rapporto con l'Esercizio; (c) società esterne al Gruppo American Express, di cui American Express potrebbe avvalersi nell'ambito della gestione del rapporto contrattuale con l'Esercizio per lo svolgimento di: (i) servizi bancari, finanziari e assicurativi, ivi compresi i soggetti che intervengono nella gestione dei sistemi di pagamento, le esattorie e le tesorerie; (ii) servizi per l'acquisizione, la registrazione e il trattamento di dati; (iii) attività di stampa, trasmissione, imbustamento, trasporto e smistamento delle comunicazioni; (iv) servizi di archiviazione della documentazione relativa ai rapporti contrattuali; (v) servizi di recupero crediti; (vi) servizi per la gestione del sistema informativo di American Express e delle reti di telecomunicazioni (ivi compresa la posta elettronica); (vii) servizi di gestione di sistemi nazionali ed internazionali per il controllo delle frodi ai danni delle banche e degli intermediari finanziari; (viii) studi o società di professionisti nell'ambito di rapporti di assistenza e consulenza; (ix) soggetti che svolgono adempimenti di controllo, revisione, e certificazione delle attività poste in essere da American Express; (x) servizi di teleselling o di call center e agenzie e/o agenti incaricati della promozione dei beni e servizi oggetto dell'attività di American Express; (xi) analisi di mercato e servizi di comunicazione per la proposizione di offerte commerciali, anche personalizzate; e (xii) enti e/o uffici pubblici, cui American Express li trasmette esclusivamente per le medesime finalità di cui sopra. I trattamenti effettuati dai soggetti qui sopra meglio descritti verranno da essi effettuati in qualità di Responsabili del trattamento dei dati nominati da American Express, per conto e sotto il controllo della stessa che rimarrà titolare del trattamento dei dati ai sensi di legge.
                                     (vi) Responsabili del trattamento dati. La lista dei responsabili dei trattamenti, tra cui Cartasì S.p.A., con sede legale in Corso Sempione n. 55, 20145 Milano, sarà mantenuta aggiornata e resa disponibile presso l'Ufficio Compliance di AEPSL.
                                     (vii) Diritti di cui all'art. 7 del Codice Privacy. L'Articolo 7 del Codice conferisce all'Esercizio (se persona fisica) e agli altri eventuali interessati taluni specifici diritti. In particolare, gli interessati possono ottenere da American Express la conferma dell'esistenza o meno di propri dati personali e che tali dati siano messi a disposizione in forma intelligibile. Gli interessati possono, altresì, chiedere di conoscere l'origine dei dati nonché la logica e le finalità su cui si basa il trattamento; possono ottenere la cancellazione, la trasformazione in forma anonima o il blocco dei dati trattati in violazione del Codice nonché l'aggiornamento, la rettifica o, se vi è interesse, l'integrazione dei dati; possono opporsi per motivi legittimi al trattamento stesso e, in ogni caso, al trattamento dei dati per fini commerciali. Per tutto ciò gli interessati potranno rivolgersi direttamente all'Ufficio Reclami, all'indirizzo di Viale Alexandre Gustave Eiffel n.15, 00148 ovvero al numero 06 722801.

                           </textarea>
                            </Paragraph>

                            <Heading level='3' className='titleParagraph'>
                                Termini e condizioni
                        </Heading>
                            <Paragraph className='textParagraph'>
                                Prima di proseguire ti invitiamo a prendere visione dei termini e delle condizioni del servizio Esercizi Online.
                            <br />
                                <br />
                                <textarea style={{ width: '100%', height: '100px' }}>
                                    TERMINI E CONDIZIONI DEL SERVIZIO ESERCIZI ONLINE
                                     1. ADESIONE AL SERVIZIO - REQUISITI TECNICI
                                     a. Previo completamento delle formalità previste per l'adesione al Servizio Esercizi Online (qui di seguito definito il "Servizio"), le informazioni sul tuo Estratto Conto mensile saranno disponibili esclusivamente mediante consultazione on-line utilizzando il tuo codice identificativo ("user id") e la tua password (qui di seguito definite le "Credenziali di Autenticazione") per l'accesso all'area protetta del sito www.americanexpress.it.
                                     A decorrere dal momento del perfezionamento della tua adesione al Servizio, American Express cesserà automaticamente di inviarti tramite posta gli Estratti Conto cartacei.
                                     Qualora il tuo Esercizio abbia più filiali e desideri avere accesso anche alle loro informazioni, dovrai registrarti una seconda volta sul sistema con il Codice Esercizio della Sede Centrale, inserendo i dati del legale rappresentante e l'importo lordo di uno degli ultimi tre estratti conto, per creare le diverse Credenziali di Autenticazione per tale tipo di accesso.
                                     b. Sarà tua cura e responsabilità disporre di un computer compatibile, di un software e delle linee di comunicazione necessarie per avere accesso al Servizio.
                                     American Express non si assume alcuna responsabilità ove il Servizio non sia utilizzabile per inidoneità delle tue apparecchiature e/o software e/o linee di comunicazione.
                                     Sarà a tuo carico e responsabilità qualsiasi costo per le telecomunicazioni o simili addebiti per l'accesso e l'utilizzo del Servizio.
                                     2. ACCESSO E MODALITA' DEL SERVIZIO
                                     a. L'adesione al Servizio è gratuita e permette di visualizzare on line gli Estratti Conto degli ultimi 13 mesi relativi al tuo Esercizio e, solo nel caso in cui sia registrato anche come Sede Centrale, potrai visualizzare anche gli Estratti Conto di tutte le tue filiali.
                                     Se si ricevono pagamenti centralizzati, le informazioni sui pagamenti di tutte le filiali saranno disponibili on line in un Rapporto consolidato.
                                     Se il tuo Esercizio è una filiale, i tuoi Estratti Conto saranno accessibili anche alla Sede Centrale.
                                     b. American Express si riserva la facoltà di modificare le condizioni di accesso al Servizio nonché le modalità di svolgimento del Servizio in qualsiasi momento, dandone comunicazione sul sito American Express. American Express si riserva, altresì, la facoltà di revocare, sospendere o porre fine al Servizio in qualsiasi momento; salvo che ricorrano motivi di sicurezza o circostanze al di fuori del controllo di American Express e salvo il caso di frodi o violazioni dei Termini e Condizioni del Servizio, American Express darà un preavviso di giorni sette della revoca, sospensione o cessazione del Servizio.
                                     3. USI NON AUTORIZZATI DEL SERVIZIO
                                     American Express non sarà responsabile per eventuali usi fraudolenti od usi non autorizzati del Servizio da parte tua o di qualsiasi altra persona in relazione alla divulgazione di informazioni riservate da parte di American Express qualora ciò sia dovuto alla mancata adozione da parte tua di idonee precauzioni per mantenere riservate le tue Credenziali di Autenticazione e/o qualora la diffusione delle informazioni sia comunque dipesa da fatti non imputabili ad American Express.
                                     4. ATTIVAZIONE SERVIZIO
                                     Qualora i dati da te forniti per la registrazione fossero incongruenti con quelli riguardanti la tua posizione e già contenuti nell'archivio American Express, non sarà possibile procedere all'assegnazione della user id e, quindi, il Servizio non verrà attivato.
                                     5. DISATTIVAZIONE
                                     Il Servizio potrà essere disattivato in qualsiasi momento chiamando direttamente il Servizio Clienti Esercizi Convenzionati di American Express allo 06 72490 dal lunedì al venerdì dalle ore 9.00 alle ore 18.00. Su tua esplicita richiesta, da comunicare al Servizio Clienti Esercizi Convenzionati contestualmente alla disdetta, in caso di disattivazione del Servizio, American Express provvederà ad inviarti nuovamente per posta gli Estratti Conto Carta cartacei con effetto dal mese successivo a quello in cui hai richiesto la disattivazione del Servizio.
                                     6. MODIFICHE E/O INATTIVITA' INDIRIZZO POSTA ELETTRONICA
                                     Dovrai comunicare ad American Express qualsiasi modifica relativa ai dati del tuo Esercizio ovvero delle sue eventuali filiali; in caso di tua omissione nell'effettuare tali comunicazioni American Express non risponderà di eventuali disservizi o impossibilità di accedere ai dati degli Estratti Conto.
                                     7. RINVIO ALL'ACCORDO ESERCIZI COMMERCIALI
                                     I termini e le condizioni generali per la partecipazione al Servizio Carta American Express contenuti nell'Accordo da te stipulato con American Express si intendono richiamati e pienamente confermati, salvo quanto specificamente previsto nelle presenti condizioni.

                           </textarea>
                            </Paragraph>

                            <Heading level='3' className='titleParagraph'>
                                Dichiarazione di consenso
                        </Heading>
                            <Paragraph className='textParagraph'>
                                Preso atto dei termini/condizioni e dell'informativa di cui sopra, accetto i termini e le condizioni e autorizzo il trattamento e la comunicazione dei miei dati per gli scopi inerenti l'attività dichiarata.
                        </Paragraph>

                        </Box>
                        <Box className='informativa' align='start'>
                            <CheckBox className='checkbox' color='#006FCF' checked={this.state.checked} id='authorization' label='Autorizzo' onChange={this.setCheckbox} />
                        </Box>


                        <Box className='informativa' align='center'>
                            <Button onClick={this.goToValidate} disabled={window.location.pathname === "/SocietyRegistration" ? !isEnabledSocieta : !isEnabledPV}
                                style={{ margin: '50px 0', width: '190px' }} color='transparent' className='btnform' label='INVIA RICHIESTA' />
                        </Box>
                        {this.state.loading ? loader : ''}

                    </Box>
                </Box>


                <Footer />

            </Box>
        )
    }
}
export default Registration = withRouter(Registration);